import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

import colors from "../../styles/settings/colors.scss";
import styles from "./Indicator.scss";

export function Indicator({
  children,
  content,
  bgColor,
  color,
  size,
  align,
  ...otherProps
}) {
  const indicatorClasses = classNames(styles.indicator, size, styles[align], {
    [styles.standalone]: !children,
  });

  return (
    <span className={styles.wrapper}>
      {children}
      <span
        className={indicatorClasses}
        style={{
          backgroundColor: bgColor,
          color,
        }}
        {...otherProps}
      >
        {content}
      </span>
    </span>
  );
}

Indicator.Size = {
  xxsmall: styles.xxsmall,
  xsmall: styles.xsmall,
  small: styles.small,
  medium: styles.medium,
  large: styles.large,
  xlarge: styles.xlarge,
  xxlarge: styles.xxlarge,
  xxxlarge: styles.xxxlarge,
};

Indicator.Color = colors;

Indicator.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.arrayOf(PropTypes.node),
  ]),
  content: PropTypes.node.isRequired,
  bgColor: PropTypes.string,
  color: PropTypes.string,
  size: PropTypes.string,
  align: PropTypes.oneOf([
    "top",
    "top-right",
    "right",
    "bottom-right",
    "bottom",
    "bottom-left",
    "left",
    "top-left",
  ]),
};

Indicator.defaultProps = {
  children: null,
  bgColor: Indicator.Color["function-green"],
  color: Indicator.Color.white,
  size: Indicator.Size.xsmall,
  align: "top-right",
};

Indicator.displayName = "Indicator";

export default Indicator;
